module.exports = __webpack_public_path__ + "img/raindrops.95b490cd.png";